import React, { useState } from "react";
import { db } from "../../firebase";
import { doc, addDoc, collection } from "firebase/firestore";
import contact from "../../img/contact.jpg";
import { async } from "@firebase/util";
import emailjs from "emailjs-com";
export default function Contact() {
  const [data, setData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;
    setData({ ...data, [name]: value });
  };

  const submitData = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contact"), {
        name: data.name,
        email: data.email,
        subject: data.subject,
        message: data.message,
      });
      alert(
        "Your query has been updated usccesfully , we will get you in touch soon!!"
      );
    } catch (error) {
      alert(error.message);
    }
    emailjs.sendForm(
      "service_prd3xru",
      "template_2nza0gl",
      e.target,
      "TVSIZEBcWhq-Oy-_W"
    );
    setData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <>
      <section id="contact" className="contact">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Contact</h2>
            <h3>
              <span>Contact Us</span>
            </h3>
            <p>
              For any general queries ,fill the below form and we will get you
              in touch very soon!!
            </p>
          </div>

          <div className="row" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-6">
              <div className="info-box mb-4">
                <i className="bx bx-map"></i>
                <h3>Our Address</h3>
                <p>Sr. No 27, Pune-Satara Road Dhankawadi, Pune-411 043</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="info-box  mb-4">
                <i className="bx bx-envelope"></i>
                <h3>Email Us</h3>
                <p>camapusselectionsystem@gmail.com</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="info-box  mb-4">
                <i className="bx bx-phone-call"></i>
                <h3>Call Us</h3>
                <p>+1 1234567890</p>
              </div>
            </div>
          </div>

          <div className="row" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-6 ">
              <img
                className="mb-4 mb-lg-0 contact-img rounded float-left img-fluid"
                src={contact}
                alt=""
              />
            </div>

            <div className="col-lg-6">
              <form
                action="/#"
                method="post"
                className="php-email-form"
                onSubmit={submitData}
              >
                <div className="row">
                  <div className="col form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      value={data.name}
                      onChange={postUserData}
                      required
                    ></input>
                  </div>
                  <div className="col form-group">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      value={data.email}
                      onChange={postUserData}
                      required
                    ></input>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Subject"
                    value={data.subject}
                    onChange={postUserData}
                    required
                  ></input>
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    placeholder="Message"
                    value={data.message}
                    onChange={postUserData}
                    required
                  ></textarea>
                </div>
                <div className="my-3">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">
                    Your message has been sent. Thank you!
                  </div>
                </div>
                <div className="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
